import React, { useContext } from "react";
import ScrollToTop from "react-scroll-to-top";
import About from "../components/Home/About";
import Banner from "../components/Home/Banner";
// import { AuthContext } from "../contex/AuthProvider";

const Home = () => {
  // const auth = useContext(AuthContext);
  return (
    <div>
      <Banner />
      <About />
    </div>
  );
};

export default Home;
